module.exports = __webpack_public_path__ + "static/logo-full-white-ce7a6f8f5e260050d0cf75f565fff538.svg";